/** Sortierung und Zeilenumbrüche für Ordner-Chips (Projekte & Stundennachweise). */

export type OrdnerChipLike = { nummer: string };

export function ordnerKeyPrefix(nummer: string): string {
  const t = nummer.trim();
  const i = t.indexOf("-");
  if (i <= 0) return t.length ? t : "\u0000";
  const head = t.slice(0, i).trim();
  return head.length ? head : "\u0000";
}

function comparePrefixKeys(a: string, b: string): number {
  const na = Number(a);
  const nb = Number(b);
  const aIsNum = Number.isFinite(na) && String(na) === a;
  const bIsNum = Number.isFinite(nb) && String(nb) === b;
  if (aIsNum && bIsNum) return na - nb;
  return a.localeCompare(b, "de", { numeric: true });
}

export function sortOrdnersForChipLayout<T extends OrdnerChipLike>(list: T[]): T[] {
  return [...list].sort((a, b) => {
    const cmp = comparePrefixKeys(ordnerKeyPrefix(a.nummer), ordnerKeyPrefix(b.nummer));
    if (cmp !== 0) return cmp;
    return a.nummer.localeCompare(b.nummer, "de", { numeric: true });
  });
}

export function parseSOrdnerNumber(nummer: string): number | null {
  const m = String(nummer).trim().match(/^S(\d+)/i);
  const digits = m?.[1];
  if (!digits) return null;
  const n = Number.parseInt(digits, 10);
  return Number.isFinite(n) ? n : null;
}

export function sOrdnerDecadeKey(nummer: string): number {
  const n = parseSOrdnerNumber(nummer);
  if (n == null) return Number.MAX_SAFE_INTEGER;
  return Math.floor(n / 10);
}

export function sortSOrdnersForChipLayout<T extends OrdnerChipLike>(list: T[]): T[] {
  return [...list].sort((a, b) => {
    const na = parseSOrdnerNumber(a.nummer);
    const nb = parseSOrdnerNumber(b.nummer);
    if (na != null && nb != null && na !== nb) return na - nb;
    if (na != null && nb == null) return -1;
    if (na == null && nb != null) return 1;
    return a.nummer.localeCompare(b.nummer, "de", { numeric: true });
  });
}

export function ordnerChipNeedsPrefixBreak(prevNummer: string | undefined, nummer: string): boolean {
  if (!prevNummer) return false;
  return ordnerKeyPrefix(prevNummer) !== ordnerKeyPrefix(nummer);
}

export function sOrdnerChipNeedsDecadeBreak(prevNummer: string | undefined, nummer: string): boolean {
  if (!prevNummer) return false;
  return sOrdnerDecadeKey(prevNummer) !== sOrdnerDecadeKey(nummer);
}
